import { parse, serialize } from 'tinyduration';
import Store from '@/vuex/store';
import Router from '@/router';
import Vue from 'vue';
import { sum, number, round, smaller } from 'mathjs';
import { sorting_options } from './utilities/sorting';
import { get_markup } from './flight-offer';

export default {
  methods: {
    log: function (...value) {
      if (process.env.VUE_APP_MODE !== 'development') return;
      window.console.log(...value);
    },
  },
};

export function parse_flight_offers_duration(duration) {
  return parse(duration);
}

export function encode_flight_offers_duration(duration) {
  return serialize(duration);
}

export function remove_time_from_date(date = new Date()) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

export function parse_flight_offers_date(flight_offer_date) {
  let split = flight_offer_date.split('T'),
    day_number = split[0].split('-')[2],
    month_number = split[0].split('-')[1],
    year = split[0].split('-')[0],
    new_date = new Date(year, parseInt(month_number) - 1, day_number),
    month_string = new_date.toLocaleString('default', { month: 'long' });

  if (split[1] && split[1].length > 5) split[1] = split[1].slice(0, -3); // rimuove i secondi (:00)

  // yyy-mm-dd to dd-mm-yyyy
  function pad(s) {
    return s < 10 ? '0' + s : s;
  }
  var d = new Date(split[0] + ' ' + split[1]);

  let readable_datetime =
    [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('-') + ' ' + split[1];

  return {
    day: split[0],
    hour: split[1],
    day_number: split[0].split('-')[2],
    month_number: split[0].split('-')[1],
    year: split[0].split('-')[0],
    month_string: month_string,
    readable_datetime: readable_datetime,
    friendly_date: day_number + ' ' + month_string + ' ' + split[0].split('-')[0],
    friendly_date_short: day_number + ' ' + month_string.slice(0, 3).toUpperCase(),
    date: new_date,
  };
}

export function is_development() {
  if (process.env.VUE_APP_MODE == 'development') return true;
  return false;
}

export function is_authenticated() {
  let token = Store.state.token;

  // se c'è un token in get ha la precedenza (quello nello state potrebbe essere scaduto)
  if (Router.history.current.query.token) token = Router.history.current.query.token;

  // non ho trovato alcun token
  if (!token) return false;

  // ho un token ma NON un'integrazione

  // implementazione cancellara -> integration nello state
  // if(!Store.state.integration || !Store.state.integration.integration) return false

  // implementazione livetravel -> integration solo nel config
  if (
    !Vue.prototype.$config ||
    !Vue.prototype.$config.integration ||
    !Vue.prototype.$config.integration.integration
  )
    return false;

  return true;
}

export function reverse_date(date) {
  // yyyy-mm-dd to dd-mm-yyyy and viceversa

  //return date.split('-').reverse().join('-');

  if (date == '') return '';

  function pad(s) {
    return s < 10 ? '0' + s : s;
  }

  let dateToUse = date;

  if (date.indexOf('T') == -1) dateToUse = date + 'T00:00:00'; // se non c'è l'orario viene applicato il fuso dell'utente

  var d = new Date(dateToUse);

  let reversed = [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('-');

  /*window.console.table({
    date: date,
    d_wo_time: new Date(date),
    dateToUse: dateToUse,
    d: d,
    reversed: reversed
  })*/

  return reversed;
}

export function custom_event(action, label, value, category) {
  label = label || '';
  value = value || 0;
  category = category || '';

  if (Vue.prototype.$gtm) {
    let gtmPayload;
    if (typeof action === 'object') {
      // custom_event usata per passare direttamente eventi GA4
      gtmPayload = action;
    } else {
      gtmPayload = {
        event: 'customEvent',
        category: category ? category : 'ce',
        action: action,
        label: label,
        value: value,
      };
    }
    Vue.prototype.$gtm.trackEvent(gtmPayload);
  }

  if (typeof action === 'object') action = action.event; // nel caso sia stato passato direttamente evento GA4

  if (window.clarity) window.clarity('set', action, label);

  if (window.LogRocket) window.LogRocket.track(action + '_' + label);

  if (window.fbq) {
    if (action == 'formSubmit') window.fbq('track', 'Lead', {});
  }
}

export function parse_flight_offer_for_ecommerce_item(flightOffer) {
  const brand = `${flightOffer.source}-${flightOffer.itineraries[0].segments[0].carrierCode}`;

  const itemName = flightOffer.itineraries
    .map((itinerary) => {
      return itinerary.segments
        .map((segment) => {
          return `${segment.departure.iataCode}${segment.arrival.iataCode}`;
        })
        .join('-');
    })
    .join('/');

  const price = flightOffer.price.grandTotal;

  const firstSegment = flightOffer.itineraries[0].segments[0];
  const itemId = [
    firstSegment.departure && firstSegment.departure.at ? firstSegment.departure.at : '',
    firstSegment.aircraft && firstSegment.aircraft.code ? firstSegment.aircraft.code : '',
    firstSegment.number ? firstSegment.number : '',
  ].join('|');

  return {
    item_id: itemId,
    item_name: itemName,
    item_brand: brand,
    price: price,
    item_category: '',
  };
}

const flight_offer_total_duration = (flight_offer) => {
  if (flight_offer.itineraries.length === 1) {
    return flight_offer.itineraries[0].duration;
  }

  const total = flight_offer.itineraries.reduce((tot, itinerary) => {
    const duration = parse_flight_offers_duration(itinerary.duration);
    const timestamp =
      (duration.days || 0) * 86400 + (duration.hours || 0) * 3600 + (duration.minutes || 0) * 60;
    return tot + timestamp;
  }, 0);

  return encode_flight_offers_duration({
    days: Math.floor(total / 86400),
    hours: Math.floor(total / 3600) % 24,
    minutes: Math.floor(total / 60) % 60,
  });
};

export const flight_offer_average_duration = (flight_offer, encoded = true) => {
  const total =
    flight_offer.itineraries.reduce((tot, itinerary) => {
      const duration = parse_flight_offers_duration(itinerary.duration);
      const timestamp =
        (duration.days || 0) * 86400 + (duration.hours || 0) * 3600 + (duration.minutes || 0) * 60;
      return tot + timestamp;
    }, 0) / flight_offer.itineraries.length;

  if (encoded) {
    return encode_flight_offers_duration({
      days: Math.floor(total / 86400),
      hours: Math.floor(total / 3600) % 24,
      minutes: Math.floor(total / 60) % 60,
    });
  }
  return total;
};

export function parse_flight_offers(flightOffers) {
  const flights = flightOffers.data ? flightOffers.data : [];
  const dictionaries = flightOffers.dictionaries ? flightOffers.dictionaries : {};
  const meta = flightOffers.meta ? flightOffers.meta : {};
  let best_picks = {};
  if (flightOffers.bestFlight && flightOffers.bestFlight.benchmarks) {
    Object.keys(sorting_options).forEach((sorting) => {
      let flight_offer_id = flightOffers.bestFlight.bestOfferId;
      if (sorting === 'price') {
        flight_offer_id = flightOffers.bestFlight.benchmarks.bestPriceId;
      }
      if (sorting === 'duration') {
        flight_offer_id = flightOffers.bestFlight.benchmarks.bestDurationId;
      }

      const flight_offer = flights.find((f) => f.id === String(flight_offer_id));
      if (flight_offer) {
        best_picks[sorting] = {
          total_duration: flight_offer_total_duration(flight_offer),
          duration: flight_offer_average_duration(flight_offer),
          flight_offer_id: String(flight_offer_id),
          rankings: flightOffers.bestFlight.metadata || {},
          price: {
            ...flight_offer.price,
            ...get_markup(flight_offer),
          },
        };
      }
    });
  }
  return {
    best_picks,
    flights: flights,
    //offers: offersSorted,
    dictionaries: dictionaries,
    meta: meta,
  };
}

// se un itinerary ha più segmenti gestiti dallo stesso air carrier ne stampo uno solo
export function parse_flight_offers_itinerary_carriers(segments) {
  let carriers = [];
  segments.forEach((segment) => {
    carriers.push(segment.carrierCode);
  });
  return [...new Set(carriers)];
}

export function parse_flight_offers_carriers(flight_offer) {
  let carriers = [];
  flight_offer.itineraries.forEach((i) => {
    let c = parse_flight_offers_itinerary_carriers(i.segments);
    carriers = [...carriers, ...c];
  });
  return [...new Set(carriers)];
}

export function parse_flight_offers_classes(flight_offer) {
  let classes_by_segment = {
    //segment_id: [classe_pax_1, classe_pax_2, ...]
  };

  let cabins = {
    ECONOMY: 'Economy',
    PREMIUM_ECONOMY: 'Premium economy',
    BUSINESS: 'Business',
    FIRST: 'First',
  };

  // in caso di schedule changes possono mancare i fareDetailsBySegment dei segmenti modificati
  // quindi preparo classes_by_segment popolando con gli id dei segmenti che trovo negli itinerari
  // così se manca un fareDetailsBySegment non si pianta il rendering
  flight_offer.itineraries.forEach((it) => {
    it.segments.forEach((seg) => {
      classes_by_segment[seg.id] = [];
    });
  });

  flight_offer.travelerPricings.forEach((t) => {
    if (t.fareDetailsBySegment) {
      t.fareDetailsBySegment.forEach((f) => {
        if (!classes_by_segment[f.segmentId]) classes_by_segment[f.segmentId] = [];
        if (f.cabin) {
          // "traduce" e pusha
          classes_by_segment[f.segmentId].push(cabins[f.cabin] ? cabins[f.cabin] : f.cabin);

          // elimina duplicati
          classes_by_segment[f.segmentId] = classes_by_segment[f.segmentId].filter(
            (element, index) => {
              return classes_by_segment[f.segmentId].indexOf(element) === index;
            }
          );
        }
      });
    }
  });

  return classes_by_segment;
}

export function deep_clone(obj) {
  return JSON.parse(JSON.stringify(obj));
}

export function is_mobile() {
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    return true;
  } else {
    return false;
  }
}

export function format_date_YYYY_MM_DD(date = new Date(), separator = '') {
  // nested arrow function
  let pad_to_2_digits = (num) => {
    return num.toString().padStart(2, '0');
  };
  return [
    date.getFullYear(),
    pad_to_2_digits(date.getMonth() + 1),
    pad_to_2_digits(date.getDate()),
  ].join(separator);
}

export function get_config(path, fallback) {
  path = path || false;
  fallback = fallback || false;

  if (!path) return Vue.prototype.$config;

  const keys = path.split('.');
  let value = Vue.prototype.$config;

  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    if (value === undefined || value === null) {
      return fallback;
    }
    value = value[key];
  }
  return value;
}

export function get_availability(price) {
  price = price || 0;

  let config = get_config(),
    discount_codes = Store.state.discount_codes,
    availability = {
      total: 0,
      welfare: false,
      is_known: false,
      details: {
        integration: 0,
        discount_codes: 0,
      },
      affordable: true,
    },
    is_jointly = config.integration.integration == 'jointly';

  if (config == undefined) return availability;
  if (config.integration == undefined) return availability;

  // config.integration.availability può arrivare -1 ad indicare che il credito non è conosciuto
  let cia = round(number(config.integration.availability), 2);

  let real_availability = cia > 0 ? cia : 0;

  availability.total = real_availability;
  availability.details.integration = real_availability;
  availability.welfare = config.integration.welfare ? true : false;
  availability.is_known = cia > -1 ? true : false; // per tracciare se la disponibilità è conosciuta oppure no

  if (discount_codes.length) {
    discount_codes.forEach((dc) => {
      availability.details.discount_codes = sum(
        availability.details.discount_codes + dc.valueResidual
      );
      availability.total = sum(availability.total + dc.valueResidual);
    });
  }

  if (price > 0 && availability.is_known && !is_jointly) {
    if (smaller(availability.total, price)) availability.affordable = false;
  }

  return availability;
}

export function formatPassengerName(passenger, fullName = false) {
  if (!passenger) return '';
  return [
    passenger.firstname,
    fullName ? passenger.middlename : undefined,
    passenger.lastname,
    fullName ? passenger.second_lastname : undefined,
  ]
    .filter((e) => !!e)
    .join(' ');
}

export function formatSegmentLabel(segmentInfo) {
  const { arrival, departure } = segmentInfo;
  return departure.iataCode + ' › ' + arrival.iataCode;
}

export const formatPrice = (price) => {
  const roundedPrice = String(round(price, 2));

  if (!roundedPrice.includes('.')) {
    return roundedPrice + '.00';
  }

  try {
    const decimals = roundedPrice.split('.')[1];
    return roundedPrice + (decimals.length === 1 ? '0' : '');
  } catch (e) {
    return roundedPrice;
  }
};

export const is_infant = (traveler) =>
  !!traveler &&
  ['HELD_INFANT', 'SEATED_INFANT'].includes(traveler.traveler_type || traveler.travelerType);
export const is_child = (traveler) =>
  !!traveler && (traveler.traveler_type || traveler.travelerType) === 'CHILD';
export const is_adult = (traveler) =>
  !!traveler && (traveler.traveler_type || traveler.travelerType) === 'ADULT';

const OBJECT_PATH_SEPARATOR = '.';

export const getObjectField = (obj, path, defaultValue) => {
  // Found the value, return it to caller
  if (obj[path]) {
    return obj[path];
  }
  const pathSteps = path.split(OBJECT_PATH_SEPARATOR);
  if (obj[pathSteps[0]]) {
    return getObjectField(
      obj[pathSteps[0]],
      pathSteps.slice(1, pathSteps.length).join(OBJECT_PATH_SEPARATOR),
      defaultValue
    );
  }

  // If we cannot go deeper go to default
  return defaultValue;
};

export const setObjectField = (obj, path, value) => {
  const pathSteps = path.split(OBJECT_PATH_SEPARATOR);
  if (pathSteps.length > 1) {
    return {
      ...obj,
      [pathSteps[0]]: setObjectField(
        obj[pathSteps[0]] || {},
        pathSteps.slice(1, pathSteps.length).join(OBJECT_PATH_SEPARATOR),
        value
      ),
    };
  }
  return { ...obj, [path]: value };
};

export const capitalize = (text = '') =>
  String(text).charAt(0).toUpperCase() + String(text).slice(1).toLowerCase();

const CURRENCY_SYMBOLS = {
  EUR: '€',
};

export const currency = (verbose = '') => CURRENCY_SYMBOLS[verbose.toUpperCase()] || verbose;

const MONTHS = {
  0: 'gennaio',
  1: 'febbraio',
  2: 'marzo',
  3: 'aprile',
  4: 'maggio',
  5: 'giugno',
  6: 'luglio',
  7: 'agosto',
  8: 'settembre',
  9: 'ottobre',
  10: 'novembre',
  11: 'dicembre',
};

export const verbose_month = (month_index) => MONTHS[month_index] || '';
